import Head from 'next/head';
import React, { FunctionComponent, useMemo } from 'react';
import GraphImg from '@graphcms/react-image';
import getGraphImageSrcSet from '../../utils/graphcms/getGraphImageSrcSet';

export interface GraphCMSImageProps {
  image: {
    handle: string,
    width: number,
    height: number,
  },
  maxWidth: number,
  alt: string,
  title?: string,
}

const GraphCMSImage: FunctionComponent<GraphCMSImageProps> = ({
  image,
  maxWidth,
  alt,
  title,
}) => {
  const { src, srcSetString, sizes } = useMemo(() => getGraphImageSrcSet(image, maxWidth), [image, maxWidth]);

  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          imageSrcSet={srcSetString}
          href={src}
          sizes={sizes}
        />
      </Head>
      <GraphImg
        image={image}
        alt={alt}
        title={title}
        maxWidth={maxWidth}
        blurryPlaceholder={false} // Keep it for performance reasons
        backgroundColor // Keep it for performance reasons
        fadeIn={false}
        withWebp
      />
    </>
  );
};

export default GraphCMSImage;
